// extracted by mini-css-extract-plugin
module.exports = {"div":"Sect4_Before5_div__3sZHu"};